import React from "react";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";

/**
 * Header "Ordering as" was superseded by the Fortius-style per-cart-group
 * Prescriber dropdown on patient groups (`GroupedByPatientCartItems`).
 * Keep the extension registered so nothing else reclaims the slot, but render nothing.
 */
const HeaderOrderingAsProviderExtension: React.FC = () => null;

registerExtension(
  "_site.header.beforeMiniMenu",
  HeaderOrderingAsProviderExtension,
  "HeaderOrderingAsProviderExtension",
);
